import Vue from "vue";
import BackTop from "./BackTop";
import NavBar from "./NavBar";

// register global components
Vue.component("back-top", BackTop);
Vue.component("nav-bar", NavBar);
